import { useState } from "react";
import { Employee } from "src/redux/types/_employee.type";
import GoalViewDialog from "./goal-view-dialog";

const GoalEmployeeList = ({ employees }: { employees: Employee[] }) => {
  const [empId, setEmpId] = useState<number | null>(null);
  const [open, setOpen] = useState(false);

  const handleOpen = (id: number) => {
    setEmpId(id);
    setOpen(true);
  };

  const handleClose = () => {
    setEmpId(null);
    setOpen(false);
  };

  return (
    <div>
      {employees.length > 0 && (
        <table className="w-full text-sm">
          <thead>
            <tr className="text-gray-600 border-b">
              <th className="py-2 text-left">Emp_ID</th>
              <th className="py-2 text-left">Name</th>
              <th className="py-2 text-left">Department</th>
              <th className="py-2 text-left">Designation</th>
              <th className="py-2 text-left">Reporting to</th>
              <th className="py-2 text-left">Actions</th>
            </tr>
          </thead>
          <tbody>
            {employees.map((emp) => (
              <tr
                key={emp.id}
                className="border-b last:border-0 hover:bg-gray-50 transition text-xs"
              >
                <td className="py-1 uppercase">{emp.employee_code}</td>
                <td className="py-1 flex flex-col">
                  <div>
                    <p className="font-medium uppercase">{emp.full_name}</p>
                    <p className="text-gray-600">{emp.email}</p>
                    <p className="text-gray-600">{emp.phone_number}</p>
                  </div>
                </td>
                <td className="py-1 uppercase">{emp.department}</td>
                <td className="py-1 uppercase">{emp.designation}</td>
                <td className="py-1 uppercase">{emp.reporting_manager_name}</td>
                <td>
                  <button
                    onClick={() => handleOpen(emp.id)}
                    className="px-4 py-3 rounded-lg hover:bg-gray-200 transition-all duration-300 ease-in-out"
                  >
                    Goals
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {empId && (
        <GoalViewDialog open={open} close={handleClose} employeeId={empId} />
      )}
    </div>
  );
};

export default GoalEmployeeList;
